import React, { Suspense } from 'react';
import './App.css';
import MainNavigation from './MainNavigation';
import { NotificationProvider } from './Views/User/Notification/NotificationContext';

import InternetStatus from './Components/InternetStatus';
import { MuteProvider } from './MuteContext';
import Loader from './Components/Loader/Loader';

import { Helmet } from 'react-helmet';
function App() {
    return (
        <div className="App">
            <Helmet>
                <title>OMF - See the Flavor. Crave the Taste. Delivered Fast</title>
                <meta name="description" content="Oh My Food brings your cravings to life. Browse food videos, explore trending dishes, and order your next meal with one tap — all delivered to your door, fast" />
                <meta name="keywords" content="food delivery, online food, fast delivery, OMF, restaurant, order food, omyfood, ohmyfood, food videos, nearby restaurants" />
                <meta name="author" content="OMF Team" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://omyfood.io/"/>
                <meta property="og:title" content="OMF - See the Flavor. Crave the Taste. Delivered Fast" />
                <meta property="og:description" content="Oh My Food brings your cravings to life. Browse food videos, explore trending dishes, and order your next meal with one tap — all delivered to your door, fast" />
                <meta property="og:image" content="/assets/svg/logo.svg" />
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content="https://omyfood.io/" />
                <meta property="twitter:title" content="OMF - See the Flavor. Crave the Taste. Delivered Fast" />
                <meta property="twitter:description" content="Oh My Food brings your cravings to life. Browse food videos, explore trending dishes, and order your next meal with one tap — all delivered to your door, fast" />
                <meta property="twitter:image" content="/assets/svg/logo.svg" />
            </Helmet>
            <InternetStatus />
            <Suspense fallback={<Loader />}>
                <MuteProvider>
                    <NotificationProvider>
                        <MainNavigation></MainNavigation>
                    </NotificationProvider>
                </MuteProvider>
            </Suspense>
        </div>
    );
}

export default App;
